import * as React from 'react';
import {
  AlertBaseAction,
  type AlertBaseActionProps,
} from 'src/components/AlertBaseAction/AlertBaseAction';
import { styled } from '@mui/material';
import { getToken } from '@workiva/unify-tokens';
import { globalMuiClasses } from 'src/utils/cssSelectorConstants';
import { getAlertBaseStyledOverridesResolver } from '../AlertBase/styledAlertBaseOverridesResolver';

export type ToastActionProps = AlertBaseActionProps;

const UnifyToastActionRoot = styled(AlertBaseAction, {
  name: 'UnifyToastAction',
  slot: 'Root',
  overridesResolver: getAlertBaseStyledOverridesResolver('child'),
})({
  color: getToken('Component/Toast/toast-primary-action'),

  [`&:hover, &.${globalMuiClasses.focusVisible}`]: {
    color: getToken('Component/Toast/toast-primary-action-hover'),
  },
});

/**
 * Use the `ToastAction` component within the `actions` prop of a `Toast` to display up to two actions.
 */
export const ToastAction = React.forwardRef<
  HTMLButtonElement,
  ToastActionProps
>(function ToastAction(props, ref) {
  return <UnifyToastActionRoot {...props} ref={ref} />;
});

export default ToastAction;
